<template>
    <v-row>
        <v-col>
            <div style="width: 100%; height: 300px; pointer-events: none;" ref="chartdiv"/>
        </v-col>
    </v-row>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);


export default {

    computed: {
        chartData() {
            return this.$store.getters['menu/mealSplitChartData'];
        },
    },
    mounted() {
        let chart = am4core.create(this.$refs.chartdiv, am4charts.PieChart);

        chart.data = this.chartData;

        //add and configure series
        let pieSeries = chart.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = "percent";
        pieSeries.dataFields.category = "meal";
        
        //disable interactivity of chart -- disabled by pointer-events: none
        //pieSeries.slices.template.states.getKey("hover").properties.scale = 1;
        //pieSeries.slices.template.states.getKey("active").properties.shiftRadius = 0;

        // Set up slices
        pieSeries.slices.template.tooltipText = "";
        pieSeries.slices.template.alwaysShowTooltip = true;

        //add outline
        pieSeries.slices.template.stroke = am4core.color("#424242");
        pieSeries.slices.template.strokeWidth = 2;
        pieSeries.slices.template.strokeOpacity = 1;

        //move and format labels inside pie slice
        pieSeries.ticks.template.disabled = true;
        pieSeries.alignLabels = false;
        pieSeries.labels.template.text = "{category} \n {value}%";
        pieSeries.labels.template.radius = am4core.percent(-50);
        pieSeries.labels.template.fill = am4core.color("black");
        //pieSeries.labels.template.relativeRotation = 90;

        //color pie slices
        pieSeries.slices.template.propertyFields.fill = "color"

    },
    beforeDestroy() {
        if (this.chart) {
        this.chart.dispose();
        }
    },
    
}
</script>
